<template>
  <div class="-mt-36">
    <!-- Composer Cards Slider -->
    <div class="slider-container py-14">
      <div class="slider-wrapper" ref="sliderWrapper">
        <div
          class="slider-track"
          :style="{ transform: `translateX(${translateX}px)` }"
        >
          <div
            v-for="(composer, index) in duplicatedComposers"
            :key="index"
            class="composer-card"
            :style="{ height: getCardHeight(index) + 'px' }"
          >
            <img :src="composer.image" :alt="composer.name" class="image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      composers: [
        {
          name: "hero-one",
          image: require("../assets/images/pyd1.jpg"),
        },
        {
          name: "hero-two",
          image: require("../assets/images/foundation6.jpg"),
        },
        {
          name: "hero-three",
          image: require("../assets/images/pyd2.jpg"),
        },
        {
          name: "hero-four",
          image: require("../assets/images/foundation1.jpg"),
        },
        {
          name: "hero-five",
          image: require("../assets/images/foundation2.jpg"),
        },
        {
          name: "hero-six",
          image: require("../assets/images/foundation8.jpg"),
        },
        {
          name: "hero-seven",
          image: require("../assets/images/foundation8.jpg"),
        },
        {
          name: "hero-eight",
          image: require("../assets/images/pyd2.jpg"),
        },
        {
          name: "hero-nine",
          image: require("../assets/images/foundation8.jpg"),
        },
      ],
      translateX: 0,
      cardWidth: 0,
      animationId: null,
    };
  },
  computed: {
    duplicatedComposers() {
      return [...this.composers, ...this.composers];
    },
  },
  mounted() {
    this.initializeSlider();
    this.startAnimation();
  },
  beforeUnmount() {
    if (this.animationId) cancelAnimationFrame(this.animationId);
  },
  methods: {
    initializeSlider() {
      this.$nextTick(() => {
        const firstCard =
          this.$refs.sliderWrapper.querySelector(".composer-card");
        if (firstCard) {
          this.cardWidth = firstCard.offsetWidth + 16;
        }
      });
    },
    startAnimation() {
      const animate = () => {
        this.translateX -= 0.5;
        const resetPoint = -(this.cardWidth * this.composers.length);
        if (this.translateX <= resetPoint) this.translateX = 0;
        this.animationId = requestAnimationFrame(animate);
      };
      animate();
    },
    getCardHeight(index) {
      if (!this.$refs.sliderWrapper || this.cardWidth === 0) return 220;

      const wrapperWidth = this.$refs.sliderWrapper.offsetWidth;
      const wrapperCenter = wrapperWidth / 2;
      const cardCenter =
        index * this.cardWidth + this.translateX + this.cardWidth / 2;

      const distanceFromCenter = Math.abs(cardCenter - wrapperCenter);
      const maxDistance = wrapperWidth / 2;

      const heightIncrease = (distanceFromCenter / maxDistance) * 80;
      return Math.min(300, 220 + heightIncrease); // center = 220px, edge = up to 300px
    },
  },
};
</script>

<style scoped>
.slider-container {
  overflow: hidden;
  width: 100%;
}

.slider-wrapper {
  display: flex;
  width: 100%;
}

.slider-track {
  display: flex;
  gap: 1rem;
  will-change: transform;
  transition: none;
  align-items: flex-end;
}

.composer-card {
  flex-shrink: 0;
  width: 180px;
  transition: height 0.2s ease;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}

.slider-container:hover .slider-track {
  animation-play-state: paused;
}
</style>
